import { GroupFloatingButton } from '@core/components/Buttons';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { Checkbox, Grid } from '@material-ui/core';
import conciliacaoApi from 'app/services/api/conciliacaoApi';
import * as Actions from 'app/store/actions';
import { eventReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ConciliacaoContext } from './ConciliacaoContext';

const ConciliacaoMenuAcoes = ({ conciliarSelecionados, desconciliarSelecionados }) => {
  const [conciliacoes, setConciliacoes] = useContext(ConciliacaoContext).conciliacoes;
  const [searchConciliacoes, setSearchConciliacoes] = useContext(ConciliacaoContext).searchConciliacoes;
  const [filtro] = useContext(ConciliacaoContext).filtro;
  const [selecao, setSelecao] = useContext(ConciliacaoContext).selecao;
  const [selecionarTodos, setSelecionarTodos] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showMessage = (message, variant) => {
    dispatch(
      Actions.showMessage({
        message,
        variant,
      })
    );
  };

  const CONCILIACAO = 'Conciliação';

  useReduxLoading(loading);

  const disabled = selecao?.length === 0;

  const handlerConciliarSelecionados = () => {
    conciliarSelecionados(conciliacoes.filter((e) => e.selected));
    setConciliacoes(conciliacoes);
  };

  const handlerDesconciliarSelecionados = () => {
    desconciliarSelecionados(conciliacoes.filter((e) => e.selected));
  };

  const handlerAgruparSelecionados = async (handlerCloseMenu) => {
    const request = selecao.map((s) => ({
      id: s.id,
      dataHoraLancamento: s.dataHoraLancamento,
      contaBancariaId: s.contaBancariaId,
      valor: s.valor,
      tipoLancamento: s.tipoLancamentoConciliacao,
    }));

    if (selecao?.length > 1) {
      setLoading(true);

      try {
        handlerCloseMenu();

        eventReactGA(CONCILIACAO, 'Agrupar selecionados');
        await conciliacaoApi.agrupar(request);
        const res = await conciliacaoApi.buscarLancamentos(filtro);

        if (res.status === 200) {
          setSelecao([]);

          setSearchConciliacoes({
            size: res.data.lancamentoExtratoBancarioResponse.size,
            page: res.data.lancamentoExtratoBancarioResponse.number,
            totalElements: res.data.lancamentoExtratoBancarioResponse.totalElements,
            sort: searchConciliacoes?.sort,
          });

          setConciliacoes(res.data.lancamentoExtratoBancarioResponse.content);
          showMessage('Agrupamento realizado com sucesso.', 'success');
        }
      } catch (err) {
        apiUtils.handleApiError(err);
      }

      setLoading(false);
    } else {
      showMessage('É preciso selecionar mais de um lançamento para realizar o agrupamento.', 'error');
    }
  };

  const handlerDesagruparSelecionados = async (handlerCloseMenu) => {
    const request = selecao.map((s) => ({
      id: s.id,
      dataHoraLancamento: s.dataHoraLancamento,
      contaBancariaId: s.contaBancariaId,
      valor: s.valor,
      tipoLancamento: s.tipoLancamentoConciliacao,
    }));

    setLoading(true);

    try {
      handlerCloseMenu();

      eventReactGA(CONCILIACAO, 'Desagrupar selecionados');
      await conciliacaoApi.desagrupar(request);
      const res = await conciliacaoApi.buscarLancamentos(filtro);

      if (res.status === 200) {
        setConciliacoes([]);
        setSelecao([]);

        setSearchConciliacoes({
          size: res.data.lancamentoExtratoBancarioResponse.size,
          page: res.data.lancamentoExtratoBancarioResponse.number,
          totalElements: res.data.lancamentoExtratoBancarioResponse.totalElements,
          sort: searchConciliacoes?.sort,
        });

        setConciliacoes(res.data.lancamentoExtratoBancarioResponse.content);
        showMessage('Desagrupamento realizado com sucesso.', 'success');
      }
    } catch (err) {
      apiUtils.handleApiError(err);
    }

    setLoading(false);
  };

  const handleClick = () => {
    setConciliacoes([
      ...conciliacoes.map((extrato) => {
        extrato.selected = !selecionarTodos;
        return extrato;
      }),
    ]);
    setSelecionarTodos(!selecionarTodos);

    if (!selecionarTodos) {
      setSelecao(conciliacoes);
    } else {
      setSelecao([]);
    }
  };

  const acoes =
    filtro.situacao === 'CONCILIADO'
      ? [
          {
            label: 'Desconciliar selecionados',
            onClick: handlerDesconciliarSelecionados,
          },
        ]
      : [
          {
            label: 'Conciliar selecionados',
            onClick: handlerConciliarSelecionados,
          },
          {
            label: 'Agrupar selecionados',
            onClick: handlerAgruparSelecionados,
          },
          {
            label: 'Desagrupar selecionados',
            onClick: handlerDesagruparSelecionados,
          },
        ];

  return (
    <>
      {conciliacoes && conciliacoes?.length > 0 && (
        <Grid container style={{ padding: '1em' }}>
          <Grid item>
            <Checkbox
              color="primary"
              name="selecionarTodos"
              value={selecionarTodos}
              checked={selecionarTodos}
              onClick={handleClick}
            />
          </Grid>
          <Grid item xs={2} style={{ with: '100%' }}>
            <GroupFloatingButton actions={acoes} disabled={disabled} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ConciliacaoMenuAcoes;
